import type { FC } from 'react';

import { SortDirection, type SortDirectionType } from '@/api/types';

const SortIcon: FC<{ direction: SortDirectionType | null }> = ({ direction }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 6.5L8 3.5L11 6.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={direction === SortDirection.DESC ? 0.3 : 1}
    />
    <path
      d="M5 9.5L8 12.5L11 9.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={direction === SortDirection.ASC ? 0.3 : 1}
    />
  </svg>
);

export { SortIcon };
